/**
 * Result card for a payment: under review, paid, failed, cancelled...
 *
 * <PaymentOutcome tone="success" icon={<CircleCheck />} title="Payment received" actions={...}>
 *   Text
 * </PaymentOutcome>
 *
 * headingRef lets the page move focus to the title when the outcome changes.
 */
const PaymentOutcome = ({ tone = 'info', icon, title, children, actions, headingRef }) => (
  <section className="pk-card co-outcome" data-tone={tone}>
    {icon && (
      <span className="co-outcome__icon" aria-hidden="true">
        {icon}
      </span>
    )}
    <h2 className="co-outcome__title" tabIndex={-1} ref={headingRef}>
      {title}
    </h2>
    {children && <div className="co-outcome__text">{children}</div>}
    {actions && <div className="co-outcome__actions">{actions}</div>}
  </section>
);

export default PaymentOutcome;
